import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList, tagList } from './props-list';

const DEFAULT_TAG = 'span';
const DEFAULT_MODIFIERS = [];

const Label = ({ children, tag = DEFAULT_TAG, url, modifiers = DEFAULT_MODIFIERS, intcmpTag, ...props }) => {
  const classNames = getClassNames('c-label', modifiers);
  const Tag = tag;

  return (
    <Tag className={classNames} href={url} {...props} data-intcmp={intcmpTag}>
      {children}
    </Tag>
  );
};

Label.propTypes = {
  children: PropTypes.any.isRequired,
  tag: PropTypes.oneOf(tagList),
  url: PropTypes.string,
  intcmpTag: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
};

export default Label;
